import React, { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';


/* ==============================
Filters Component
================================ */
export function FarmFilters({ filters, setFilters, onApply }) {
    return (
        <div className="card mb-4 noprint">
            <div className="card-body" style={{background:"#eee"} }>
                <div className="row g-3">
                    <div className="col-md-3">
                        <label className="form-label">Farm Name</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search farm..."
                            value={filters.farm}
                            onChange={(e) =>
                                setFilters({ ...filters, farm: e.target.value })
                            }
                        />
                    </div>

                    <div className="col-md-3">
                        <label className="form-label">Primary Contact</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search primary contact..."
                            value={filters.primaryContact}
                            onChange={(e) =>
                                setFilters({ ...filters, primaryContact: e.target.value })
                            }
                        />
                    </div>

                    <div className="col-md-3 select">
                        <label className="form-label">Referred By</label>
                        <select
                            onChange={e => setFilters({ ...filters, referredBy: e.target.value })}
                            className="form-control"
                            value={filters.referredBy}
                        >
                            <option value="" >All</option>
                            <option value="ADAS">ADAS</option>
                            <option value="Agrovista">Agrovista</option>
                            <option value="Aspatria Farmers">Aspatria Farmers</option>
                            <option value="Eco Prospects">Eco Prospects</option>
                            <option value="Glasson">Glasson</option>
                            <option value="Mitchells">Mitchells</option>
                            <option value="NWA">NWA</option>
                            <option value="Other">Other</option>

                        </select>
                    </div>
                    

                    <div className="col-md-2">
                        <label className="form-label">Location</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search location..."
                            value={filters.location}
                            onChange={(e) =>
                                setFilters({ ...filters, location: e.target.value })
                            }
                        />
                    </div>
                
                
                


                    <div className="col-md-1 d-flex flex-column">
                        <button
                            className="btn btn-primary mt-auto ms-auto"
                            onClick={onApply}
                        >
                            Filter
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}